import Chip from '@components/Chip';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import useProject from '@hooks/useProject';
import useProjectId from '@hooks/useProjectId';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import usePaymentMethods from './hooks/usePaymentMethods';
import MethodItem from './MethodItem';
import MoreIcon from './MoreIcon';
import SimplePayIcon from './SimplePayIcon';
import styles from './styles.module.scss';

// 카페게이트에 한해 확장 기본 처리
const cafegateId = import.meta.env.VITE_CAFEGATE_ID;

function PaymentMethod() {
    const [isSimple, setIsSimple] = useState(false);
    const projectId = useProjectId();
    const [expand, setExpand] = useState<boolean>(projectId === cafegateId);
    const { t } = useTranslation('order');
    const methodList = usePaymentMethods();
    const project = useProject();
    if (project?.pgVendor === 'TOSS') {
        return null;
    }
    return (
        <Column as='section'
            className={styles.container}
            fullWidth>
            <Text size='lg' fontWeight='bold'>{t('paymentMethod.title')}</Text>
            <Chip.Container variant='fill' className={styles.type}>
                <Chip isSelected={!isSimple} onClick={() => setIsSimple(false)}>{t('paymentMethod.general')}</Chip>
            </Chip.Container>
            {isSimple ? (
                <SimplePayIcon/>
            ) : (
                <Column fullWidth
                    align='center'
                    className={styles.gridContainer}>
                    <div className={`${styles.gridWrapper} ${expand && styles.expand}`}>
                        <article className={styles.grid}>
                            {methodList?.map((method) => (
                                <MethodItem method={method}
                                    key={method} />
                            ))}
                        </article>
                    </div>
                    {(methodList?.length || 0) > 3 && (
                        <Column align='center'
                            onClick={() => setExpand(!expand)}
                            spacing={4}>
                            <Text color={colors.gray5}>{t('paymentMethod.morePayments')}</Text>
                            <MoreIcon className={`${styles.more} ${expand && styles.expand}`}/>
                        </Column>
                    )}
                </Column>
            )}
        </Column>
    );
}

export default PaymentMethod;
